import React from "react"
import { twMerge } from "tailwind-merge"
import Button from "aldoo-ra/Button"
import Image from "aldoo-ra/Image"

// the CMS Images: the wordmark (162x33) and the small triangle mark (37x33)
const WORDMARK = "w-[162px] h-[33px] object-contain"
const MARK = "w-[37px] h-[33px] object-contain"

/**
 * Aldoo logo link, its images from the CMS (Image "logo" and "logo_icon").
 * `small` shows the mark; `responsive` the mark below 1080px (the phone
 * layout of the bar) and the wordmark from there. Each image keeps its box
 * while it loads, so the bar does not shift. The images come with the page
 * (rendered on the server, aldoo-ra/AldooVike/hooks/onRenderHtml.js), and
 * `sizes` names their real width so the browser takes the smallest variant.
 */
export default function Logo({ small = false, responsive = false, className = "", to = "/" }) {
  return (
    <Button variant="none" href={to} className={twMerge("flex items-center h-[33px] w-fit shrink-0", className)} aria-label="Aldoo">
      {responsive ? (
        <>
          <span className={twMerge("flex lg:hidden", MARK)}>
            <Image id="logo_icon" alt="Aldoo logo" className={MARK} sizes="37px" />
          </span>
          <span className={twMerge("hidden lg:flex", WORDMARK)}>
            <Image id="logo" alt="Aldoo logo" className={WORDMARK} sizes="162px" />
          </span>
        </>
      ) : small ? (
        <span className={twMerge("flex", MARK)}>
          <Image id="logo_icon" alt="Aldoo logo" className={MARK} sizes="37px" />
        </span>
      ) : (
        <span className={twMerge("flex", WORDMARK)}>
          <Image id="logo" alt="Aldoo logo" className={WORDMARK} sizes="162px" />
        </span>
      )}
    </Button>
  )
}
